import { useLoader } from "../../components/common/LoaderContext";
import { successToast, errorToast } from "../../Utils/toast";
import { useApiClientBase } from "./apiClient";

/**
 * useDownloadApi is a custom hook that provides an API function
 * for downloading CSV data. It uses the configured API client and error handler from useApiClientBase.
 *
 * @returns { downloadCsv } - Function to download CSV data from the backend.
 */
export const useDownloadApi = () => {
  const { apiClient, handleError } = useApiClientBase();
  const { setLoading } = useLoader();

  /**
   * Downloads CSV data from the backend API.
   *
   * @param data - The request payload containing user email and any additional parameters for the download.
   * @returns {Promise<void>} - Resolves when the download is complete or shows a toast on success/failure.
   */
  const downloadCsv = async (data: any) => {
    setLoading(true);
    try {
      const response = await apiClient.post(
        `/CascadingFilter/downloadcsv?UserEmail=${data.userEmail}&CommentsStatusID=${data.CommentsStatusID}`,
        data
      );
      if (response) {
        successToast(response.data);
        setLoading(false);
      } else {
        errorToast("Some data not available for download");
      }
    } catch (err) {
      handleError(err, "Downloading CSV Failed");
      setLoading(false);
    }
  };

  return { downloadCsv };
};
